// SPDX-License-Identifier: LicenseRef-Techsafe-Proprietary
// Copyright (c) 2026 Techsafe Teknoloji ve Muhendislik A.S.
// https://techsafe-solutions.com
// Economic rights: Techsafe A.S.
// Authors' moral rights reserved under Turkish Copyright Law (FSEK 5846).
// Mali haklar Techsafe A.S.'ye aittir; eser sahiplerinin manevi haklari saklidir (FSEK 5846).
// This content was prepared with the assistance of AI tools, reviewed by a
// human, and published by Techsafe Teknoloji ve Muhendislik A.S. The publishing
// entity is responsible for accuracy and compliance.
// Bu icerik, yapay zeka destekli araclar kullanilarak hazirlanmis, insan
// incelemesinden gecirilmis ve Techsafe Teknoloji ve Muhendislik A.S.
// tarafindan yayimlanmistir. Icerigin dogrulugundan yayimlayan kurulus
// sorumludur.

// The ADR-007 D1 client-orchestrated stage sequence, plus the per-stage
// progress model (ADR-007 D5).
//
// Amended by #35 (Accepted, MR !24): "collect" now also carries an
// UNCONDITIONAL AU0001 read (a peer input to ADR-004 D3 selection, not a D1
// candidate). Selection (D3) itself is a pure client computation over
// already-fetched data — it does not get its own stage record. "enrich"
// (ADR-004 D2) is now CONDITIONAL, running only when D3's winner is
// AU0008/AU0004-sourced. "offline" (ADR-004 D6) is conditional on D3's winner
// being AU0001-sourced, not on any candidate's method label.

export type StageId =
  | "resolve" // ADR-003
  | "collect" // ADR-004 D1 (AU0008/AU0004) + unconditional AU0001 read (D3, #35)
  | "enrich" // ADR-004 D2 (conditional: winner-only, AU0008/AU0004-sourced)
  | "offline"; // ADR-004 D6 (conditional: winner is AU0001-sourced)

export type StageState = "pending" | "active" | "done" | "skipped" | "failed";

export interface StageProgress {
  readonly id: StageId;
  readonly label: string;
  state: StageState;
  /** Optional sub-text shown while the stage is active (e.g. which AU is being queried). */
  detail?: string;
}

/** User-facing stage labels (active voice, plain terms — frontend-design copy). */
export const STAGE_LABELS: Readonly<Record<StageId, string>> = {
  resolve: "Resolve device",
  collect: "Collect firmware update operations",
  enrich: "Read firmware update operation details",
  offline: "Check registered offline update logs",
};

/** Fresh progress list for a new query. Offline starts pending; may be skipped. */
export function initialProgress(): StageProgress[] {
  return (["resolve", "collect", "enrich", "offline"] as StageId[]).map((id) => ({
    id,
    label: STAGE_LABELS[id],
    state: "pending",
  }));
}
